import type { IErrorResponse } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useSendCommentNew = (): UseMutationResult<
  [],
  IErrorResponse,
  { news_id: string; content: string }
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.postNewComment, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('yourCommentSuccessfullyRegistered'),
      });
    },
  });
};

export default useSendCommentNew;
